import { createReducer } from 'redux-create-reducer'
import {
  PRELOAD_DATA_ON_LOGIN,
  PRO_ADD_SUCCESS,
  PRO_UPDATE_SUCCESS,
} from '@disco/constants/ActionTypes'
import type { Pro } from '@disco/types/types/writer'

const initialState: Array<any> = []
export type ProState = typeof initialState
export const proReducer = createReducer<ProState, any>(initialState, {
  [PRELOAD_DATA_ON_LOGIN](_state, action) {
    return action.entities.pro || initialState
  },

  [PRO_ADD_SUCCESS](state, { pros }) {
    return [...state, ...pros]
  },

  [PRO_UPDATE_SUCCESS](state, { pro }) {
    return state.map(p => (p.id === pro.id ? { ...p, ...pro } : p))
  },
})

const rightsholderProInitialState: Array<Pro> = []
export type RightsHolderProState = typeof rightsholderProInitialState
export const rightsholderProReducer = createReducer<RightsHolderProState, any>(
  rightsholderProInitialState,
  {
    [PRELOAD_DATA_ON_LOGIN](_state, action) {
      return action.entities.rightsholderPro || rightsholderProInitialState
    },
  },
)
